exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Container___1CyNc {\n  width: 100%;\n  flex: 1;\n  padding: 0.5rem;\n}\n\n.FocusTarget___3WP7F:focus {\n  outline: none;\n}\n", ""]);

// exports
exports.locals = {
	"Container": "Container___1CyNc",
	"FocusTarget": "FocusTarget___3WP7F"
};